export const REGIONAL_POWURLINE_OVERRIDE_TAGS = {
  REGIONAL_POWURLINE_OVERRIDES: "RegionalPowurlineOverrides",
} as const;
